import { TEST_IDS } from "src/apps/config/testIds";
import { Input } from "src/apps/components/inputs/Input";
import { useTranslations } from "src/apps/hooks/useTranslations";
import { FormSectionHeader } from "../../FormSectionHeader";
import {
  COMPANY_NAME_PLACEHOLDER,
  COMPANY_NAME_TITLE,
  COMPANY_NIF_PLACEHOLDER,
  COMPANY_NIF_TITLE,
  SECTION_COMPANY,
} from "../RepresentedEntityDataForm.constants";
import { Fields, Section } from "../RepresentedEntityDataForm.styles";

interface Props {
  companyNif: string;
  companyName: string;
  companyNifError: string;
  isCompanyNifEditable: boolean;
  isCompanyNameEditable: boolean;
  onCompanyNifChange: (value: string) => void;
  onCompanyNameChange: (value: string) => void;
}

export const CompanySection = ({
  companyNif,
  companyName,
  companyNifError,
  isCompanyNifEditable,
  isCompanyNameEditable,
  onCompanyNifChange,
  onCompanyNameChange,
}: Props) => {
  const { t } = useTranslations();
  return (
    <Section>
      <FormSectionHeader title={t(SECTION_COMPANY)} />
      <Fields>
        <Input
          title={t(COMPANY_NIF_TITLE)}
          placeholder={t(COMPANY_NIF_PLACEHOLDER)}
          value={companyNif}
          onChange={(e) => onCompanyNifChange(e.target.value)}
          error={t(companyNifError)}
          blocked={!isCompanyNifEditable}
          dataTestId={TEST_IDS.representedEntityData.companyNifInput}
        />
        <Input
          title={t(COMPANY_NAME_TITLE)}
          placeholder={t(COMPANY_NAME_PLACEHOLDER)}
          value={companyName}
          onChange={(e) => onCompanyNameChange(e.target.value)}
          blocked={!isCompanyNameEditable}
          dataTestId={TEST_IDS.representedEntityData.companyNameInput}
        />
      </Fields>
    </Section>
  );
};
